'use client';

import '@/lib/polyfills/request-submit';
import '@/lib/suppress-error-noise';

export function Polyfills() {
  return null;
}
